<template>
    <div class="form-check">
        <label class="form-check-label" :class="{ 'text-danger': hasError }">
            <input class="form-check-input" type="radio" v-model="model" :value="key">
            {{ label }}
        </label>
    </div>
</template>

<script>
    export default {
        name: 'Radio',
        props: {
            value: { Number, String },
            option: { String, Object },
            hasError: Boolean
        },
        computed:{
            model: {
                get() {
                    return this.value
                },
                set(val) {
                    this.$emit('input', val)
                }
            },
            key: function() {
                return this.isOptionObject ? this.option['key'] : this.option
            },
            label: function() {
                return this.isOptionObject ? this.option['label'] : this.option
            },
            isOptionObject: function() {
                return typeof this.option === 'object'
            }
        }
    }
</script>